export default __webpack_public_path__ + "static/tab7Img-95a32b4525ddc578a089da76164aaa96.png";